export default __webpack_public_path__ + "static/media/manarg.8ce897ce.svg";